module.exports = __webpack_public_path__ + "img/1602347473.3befbf54.png";